export const SEARCH_LENGTH_LIMIT = 200;
export const SEARCH_WORD_LIMIT = 10;
export const MIN_SEARCH_LENGTH = 3;